import { getBreakpoint, CROSS_BREAKPOINT, MEDIUM } from '../breakpoint-controller';

var $ = window.jQuery,
    el;

function onDocumentReady() {
    el = $('.filter-bar');

    if (el.length > 0) {
        $(document).on(CROSS_BREAKPOINT, onCrossBreakpoint);
    }

    el.on('click', '.search-submit', onClickSearchToggle);
    el.on('click', '.filter-option-add', onClickFilterOption);
    el.on('click', '.filter-toggle, .filters-close', onClickFilterBy);
    el.on('click', '.filter-name-link', function(e) {
        e.preventDefault();
        onClickFilterName($(this));
    });
}

/**
 * Handles switching between large and small layout UIs.
 * @param {object} e jQuery event.
 * @param {integer} breakpoint The breakpoint in pixels.
 */
function onCrossBreakpoint(e, breakpoint) {

    if (breakpoint >= MEDIUM) {
        largeInterface();
    } else {
        smallInterface();
    }
}

/**
 * Enables small layout UI
 */
function smallInterface() {
    el.find('.filters').hide();
    el.find('.filter-options').show().removeAttr('style');
}

/**
 * Enables large layout UI.
 */
function largeInterface() {
    el.find('.filters').show();
    el.find('.filter-options').hide().removeAttr('style');
}

/**
 * Handles the filter option click event. Only handles UI changes.
 */
function onClickFilterOption() {
    if (getBreakpoint() >= MEDIUM) {
        closeAllFilterOptions();
    }
}

/**
 * Handles the filter name click event.
 * @param {object} e jQuery event
 */
function onClickFilterName(filter) {

    if (getBreakpoint() >= MEDIUM) {
        closeAllFilterOptions();
        var options = filter.parents('.filter').find('.filter-options');
        filter.attr('aria-expanded', filter.attr('aria-expanded') === 'true' ? 'false' : 'true');
        options.stop().slideToggle(200);
    }

    return false;
}

/**
 * Handles the search filter submit button click event.
 * @param {object} e jQuery event
 */
function onClickSearchToggle(e) {
    el.find('input[type="search"]').focus();

    return false;
}

/**
 * Handles the filters toggle click event.
 * @param {object} e jQuery event
 */
function onClickFilterBy(e) {
    e.stopImmediatePropagation();

    var toggle = el.find('.filter-toggle'),
        showResults = el.find('.filters-close'),
        filters = el.find('.filters');

    filters.stop().slideToggle(200);
    filters.attr('aria-hidden', filters.attr('aria-hidden') === 'true' ? 'false' : 'true');
    toggle.attr('aria-expanded', toggle.attr('aria-expanded') === 'true' ? 'false' : 'true');
    showResults.attr('aria-expanded', showResults.attr('aria-expanded') === 'true' ? 'false' : 'true');

    return false;
}

/**
 * Closes all open filter options.
 */
function closeAllFilterOptions() {
    var allOptions = el.find('.filter-options');
    allOptions.stop().slideUp(200);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/filter-bar-ui-controller.js